import React from 'react'

import { InterviewStatus } from "../types";
import { InterviewStatusButton } from "../InterviewStatusButton";

import { PopupContainer, PopupDescription, TitleContainer, PopupTitle, StyledCrossButtonBlack } from "../CandidateView.styles";

interface ApplicationActionsProps {
    onClose: () => void;
    onNoShowButtonClick: () => void;
    onSetInterviewStatus: (newInterviewStatus: InterviewStatus) => Promise<void>;
}

const ApplicationActions = ({
    onClose,
    onNoShowButtonClick,
    onSetInterviewStatus
}: ApplicationActionsProps) => {
    return (
        <PopupContainer>
            <TitleContainer>
                <PopupTitle>Update Interview Status</PopupTitle>
                <StyledCrossButtonBlack onClick={onClose}/>
            </TitleContainer>
            <PopupDescription>
                Updating will also allow the candidate access to your contact details if they don’t already have this.
            </PopupDescription>
            <InterviewStatusButton
                interviewStatus={InterviewStatus.scheduled}
                onNoShowButtonClick={onNoShowButtonClick}
                onSetInterviewStatus={async () => await onSetInterviewStatus(InterviewStatus.scheduled)}
            />
            <InterviewStatusButton
                interviewStatus={InterviewStatus.interviewed}
                onNoShowButtonClick={onNoShowButtonClick}
                onSetInterviewStatus={async () => await onSetInterviewStatus(InterviewStatus.interviewed)}
            />
            <InterviewStatusButton
                interviewStatus={InterviewStatus.noshow}
                onNoShowButtonClick={onNoShowButtonClick}
                onSetInterviewStatus={async () => await onSetInterviewStatus(InterviewStatus.noshow)}
            />
        </PopupContainer>
    )
}

export default ApplicationActions;
